import { Box, Container,Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const InfoBlock = ({ title, items }: { title: string; items: string[] }) => (
  <Box>
    <Typography variant="h3" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Stack spacing={1}>
      {items.map((item) => (
        <Typography key={item} variant="body2" color="text.secondary">
          {item}
        </Typography>
      ))}
    </Stack>
  </Box>
);

export default function Impressum() {
  const { t } = useTranslation();
  const sections = t("imprint.sections", { returnObjects: true }) as Array<{ title: string; items: string[] }>;

  return (
    <Container sx={{ py: { xs: 4, md: 6 }, maxWidth: "md" }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h1">{t("imprint.title")}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t("imprint.subtitle")}
          </Typography>
        </Box>

        {sections.map((section) => (
          <InfoBlock key={section.title} title={section.title} items={section.items} />
        ))}
      </Stack>
    </Container>
  );
}
